var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"h-12 w-32 border-3 border-current",class:{
      'rounded-none': !_vm.rounded,
      'rounded-full': _vm.rounded,
      'w-auto': _vm.wauto
    },attrs:{"outlined":"","block":""},on:{"click":function () {
        _vm.isOpen = true;
      }}},[_c('span',{staticClass:"font-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('v-dialog',{attrs:{"max-width":"1200px"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('ContactInnerForm',{attrs:{"is-active":_vm.isOpen},on:{"send":function($event){_vm.isOpen = false}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }